

const GigsPage = () => {
  return (
    <div className="GigsPage py-12 pb-24">
      <div className="text-left max-w-md m-auto p-2">
        <h2 className="uppercase text-4xl font-bold">Keikkapyynnöt:</h2>
        <p>
          <a
            className="underline"
            href="mailto:laurimikael.musiikki@gmail.com"
          >
            laurimikael.musiikki@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default GigsPage;